export const ResourcesExchangeItems = [
    {
        price: '100',
        resourceType: 0,
        icon: 'green',
        secondaryIcon: 'red',
        tertiaryIcon: 'green',
    },
    {
        price: '200',
        resourceType: 0,
        icon: 'red',
        secondaryIcon: 'white',
        tertiaryIcon: 'green',
    },
    {
        price: '500',
        resourceType: 0,
        icon: 'green',
        secondaryIcon: 'white',
        tertiaryIcon: 'red',
    },
];
